module.exports = __webpack_public_path__ + "static/media/CHARGING_TERMINAL-2.a821f8cd.png";